import * as React from 'react'

import theme from 'theme'

const Hr: React.FC = props => (
  <hr
    css={{
      width: '100%',
      height: 1,
      marginTop: theme.space[2],
      marginBottom: theme.space[2],
      border: 0,
      boxShadow: `inset 0 -1px 0 0 ${theme.colors.border[0]}`
    }}
    {...props}
  />
)

export default Hr
